import { render, staticRenderFns } from "./loadingAnimation.vue?vue&type=template&id=45303648&scoped=true&"
import script from "./loadingAnimation.vue?vue&type=script&lang=js&"
export * from "./loadingAnimation.vue?vue&type=script&lang=js&"
import style0 from "./loadingAnimation.vue?vue&type=style&index=0&id=45303648&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45303648",
  null
  
)

export default component.exports